import type { ReactNode } from 'react';

import { useParams } from 'react-router-dom';

import { Icon } from './icon';
import { SubsetChip } from './subset-chip';

export function PageTitle({
  text,
  subtext,
  iconClass,
  showSubsetChip = false,
}: {
  text: string;
  subtext?: ReactNode;
  iconClass?: string;
  showSubsetChip?: boolean;
}) {
  const { subsetId } = useParams();

  return (
    <div className="px-1">
      <div className="flex items-center gap-4">
        <h1 className="flex items-center gap-3.5 py-0.5 font-serif text-3xl font-medium">
          {iconClass && <Icon className={`${iconClass} -mb-1 text-2xl text-gray-400`} />}
          <span className="line-clamp-1 break-all">{text}</span>
        </h1>
        {showSubsetChip && subsetId && <SubsetChip subsetId={subsetId} className="mt-0.5" />}
      </div>
      {subtext && (
        <div className="my-2 mt-1.5 text-gray-600">{typeof subtext === 'string' ? <p>{subtext}</p> : subtext}</div>
      )}
    </div>
  );
}
